<template>
  <v-app id="vapp">
    <!--version 0.9.02-->
    <!--//@*/*
    //    *RPD  Appv0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC . All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-overlay opacity="0.97" :z-index="zIndex" :value="overlay">
      <v-progress-circular
        :size="50"
        style="z-index: 5200"
        color="deep-orange accent-2"
        indeterminate
      >
      </v-progress-circular>
    </v-overlay>

    <v-app-bar
      app
      class="appBar justify-center"
      style="height: 64px"
      color="secondary"
    >
      <v-toolbar-title class="mr-2"
        >RPD NIBRS Test - Sworn v1.02</v-toolbar-title
      >
      <v-spacer class="hide-on-small"></v-spacer>
      <v-btn @click.prevent="logout" small class="mr-2"
        >Log Out {{ useremail }}</v-btn
      >
    </v-app-bar>

    <!-- <brandbar></brandbar> -->
    <v-main id="main">
      <Transition name="fade-transition" mode="out-in">
        <router-view />
      </Transition>
    </v-main>
  </v-app>
</template>

<style>
/* 0 media q */
@media (min-width: 0px) {
  .v-main {
    padding: 5px 0 0 0 !important;
  }

  #vapp {
    background-color: var(--v-background-base);
    overflow-y: auto;
    max-height: 100vh;
    height: 100vh;
    width: 100%;
    max-width: 768px;
    margin: auto;
    margin-top: 64px;
  }

  .appBar {
    /*     display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: flex-start;
    justify-content: flex-start;
    -webkit-align-items: center;
    align-items: center; */
    width: 100%;
    max-width: 768px;
    margin: auto;
  }

  .appBar .v-toolbar__title {
    font-size: 3vw;
  }

  .appBar .v-toolbar__content {
    padding: 4px 2px 4px 10px;
  }

  .appBar .v-btn.v-size--small {
    font-size: 0.5rem;
  }

  .swal2-popup {
    /* font-size: 1.15rem !important;*/
    font-family: "Roboto", sans-serif !important;
  }

  .v-btn--active.no-active::before {
    opacity: 0 !important;
  }

  .v-btn--active.no-active:not(:hover)::before {
    opacity: 0 !important;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #vapp {
    max-height: 93vh;
    width: 100%;
    max-width: 768px;
  }

  .appBar .v-toolbar__title {
    font-size: 3vw;
  }

  .appBar .v-toolbar__content {
    padding: 4px 2px 4px 10px;
  }

  .appBar .v-btn.v-size--small {
    font-size: 0.75rem;
  }
}

/* Ipad landscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .appBar .v-toolbar__title {
    font-size: 2vw;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  #vapp {
    width: 100%;
    max-width: 768px;
  }

  .appBar .v-toolbar__title {
    font-size: 1.5rem;
  }

  .appBar .v-toolbar__content {
    padding: 4px 2px 4px 10px;
  }

  .appBar .v-btn.v-size--small {
    font-size: 0.75rem;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
  #vapp {
    width: 100%;
    max-width: 768px;
  }
}
</style>

<script>
/* import brandbar from "./brandbar"; */

import { bus_common } from "../mixins/bus_common";
export default {
  name: "App",
  mixins: [bus_common],
  /* components: { brandbar }, */

  data() {
    return {
      zIndex: 4000,
    };
  },
  watch: {
    "$store.state.loader_visible": function () {
      //console.log("app loader_visible " + this.$store.state.loader_visible );
    },
  },
  computed: {
    overlay: function () {
      return this.$store.state.loader_visible;
    },
    useremail: function () {
      return this.$store.state.user.email;
    },
  },
  methods: {
    logout() {
      var self = this;
      this.swall_diag(
        "Log Out?",
        "Are you sure you would like to log out?",
        "question",
        function () {
          window.location.replace(
              "https://rpdportal.org?logout=" + this.useremail
          );
        },
        "Yes",
        "No",
        null
      );
    },
  },
  mounted() {
    this.show_loader(true);
    var self = this;
    this.$nextTick(() => {
      //  self.init();
    });
  },
  created() {
    this.show_loader(false);
  },
};
</script>
